import React from "react";
import Widget from "../Widget";
import { observer, inject } from "mobx-react";
import { action, makeObservable } from "mobx";
import Select from "react-select";
import Loader from "../../shared/Loader/Loader";
import "./Meds.scss";
import MedsStore from "./MedsStore";
import { NavLink } from "react-router-dom";
import * as _ from "lodash";
import { reactSelectTheme } from "../../shared/colorScheme";

class Meds extends Widget {
  subNavItems = [
    {
      label: "Active",
      route: "meds",
    },
    {
      label: "Inactive",
      route: "meds/inactive",
    },
  ];
  constructor(props) {
    super(props);

    makeObservable(this, {
      filter: action,
      filterChange: action,
    });

    this.store = new MedsStore();
    this.filter = this.filter.bind(this);
    this.filterChange = this.filterChange.bind(this);
    this.store.filterOptions = [
      "All",
      "Scheduled",
      "ContinuousInfusions",
      "PRN",
      "Suspended",
    ].map((option) => ({
      label: option,
      value: option,
    }));
    this.store.selectedFilterOption = this.store.filterOptions[0];
    this.observeRoute = this.observeRoute.bind(this);
    this.openMedDetail = this.openMedDetail.bind(this);
    this.store.fetchMeds(this.asmpid);
    this.refresh = this.refresh.bind(this);
  }

  componentDidMount() {
    super.componentDidMount();
    this.observeRoute(this.props.location);
    this.props.history.listen((location) => this.observeRoute(location));
  }

  render() {
    return (
      <div className="meds widget">
        <nav className="sub-nav">
          <span>
            {this.subNavItems.map((navItem) => (
              <NavLink
                key={navItem.label}
                to={`/patient/${this.asmpid}/${navItem.route}`}
                exact
              >
                {navItem.label}
              </NavLink>
            ))}
          </span>
          <div className="filter">
            <span className="label">Filter</span>
            <Select
              className="Select"
              classNamePrefix="Select"
              options={this.store.filterOptions}
              onChange={this.filterChange}
              searchable={false}
              placeholder={this.store.selectedFilterOption.label}
              theme={reactSelectTheme({ darkMode: this.props.store.darkMode })}
            />
            <input
              type="search"
              onKeyUp={this.filter}
              ref={(r) => (this.refSearch = r)}
              className="search"
            />
          </div>
        </nav>
        <div className="widget-content">
          {this.store.meds.length ? (
            <table className="meds-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Dose</th>
                  <th>Last Administered</th>
                </tr>
              </thead>
              <tbody>
                {this.store.filteredMeds.map((med, i) => (
                  <tr key={i} onClick={() => this.openMedDetail(med)}>
                    {/* There is nothing about meds that is guaranteed to be unique. */}
                    <td>{med.name}</td>
                    <td>{med.orderedItem}</td>
                    <td>{med.clinicalDisplay}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="no-data">No Active Meds</div>
          )}
          {this.store.loading ? (
            <Loader />
          ) : this.store.err ? (
            this.store.err
          ) : null}
        </div>
      </div>
    );
  }

  observeRoute(location) {
    if (location.pathname.match(/\/inactive/)) {
      this.filterChange(_.last(this.store.filterOptions));
    } else {
      this.filterChange(this.store.filterOptions[0]);
    }
  }

  refresh() {
    this.store.fetchMeds(this.asmpid);
  }

  filter() {
    this.store.searchText = _.get(this.refSearch, "value", "");
  }
  filterChange(option) {
    this.store.selectedFilterOption = option;
    this.filter();
  }

  openMedDetail(med) {
    this.props.history.push({
      pathname: `/patient/${this.asmpid}/med-detail`,
      state: med,
    });
  }
}

export default inject("store")(observer(Meds));
